import { mutatorAction } from 'satcheljs';
import type { AssetCommand } from './AssetCommand';
import assetCommandsStore from './assetCommandsStore';

/**
 * Registers commands that are type-wide, similar to how assets are registered.
 * Use this instead of the useAssetCommands hook when there should only be one instance of a command for each asset type, not each instance.
 */
export const registerAssetCommandsByType = mutatorAction(
    'registerAssetCommandByType',
    (assetType: string, commands: [AssetCommand]) => {
        const existingCommands = assetCommandsStore.assetCommandsByType.get(assetType);
        !!existingCommands?.length
            ? existingCommands.concat(...commands)
            : assetCommandsStore.assetCommandsByType.set(assetType, commands);
    }
);
